import { render, staticRenderFns } from "./TopSupplierSellingItems.vue?vue&type=template&id=a1554daa&scoped=true&"
import script from "./TopSupplierSellingItems.vue?vue&type=script&lang=js&"
export * from "./TopSupplierSellingItems.vue?vue&type=script&lang=js&"
import style0 from "./TopSupplierSellingItems.vue?vue&type=style&index=0&id=a1554daa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1554daa",
  null
  
)

export default component.exports